import { useEffect, useRef } from 'react'

function OutsideClickWrapper({ onCloseIntent, children, style, active }) {
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (!onCloseIntent || !active) {
      return
    }

    const handleClickOutside = (event) => {
      if (
        active &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        onCloseIntent?.(event)
      }
    }

    const handleEscape = (event) => {
      if (active && event.key === 'Escape') {
        onCloseIntent?.(event)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [onCloseIntent, active])

  return (
    <div ref={wrapperRef} style={style}>
      {children}
    </div>
  )
}

export default OutsideClickWrapper
